import type { Color } from 'antd/es/color-picker'

interface Shades {
  color: string
  firstShade: string
  secondShade: string
}

function rgbToHex(r: number, g: number, b: number): string {
  const toHex = (v: number) => Math.round(v).toString(16).padStart(2, '0')
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`
}

export function createColorShades(color: Color): Shades {
  const { r, g, b } = color.toRgb()

  const rRest = 255 - r
  const gRest = 255 - g
  const bRest = 255 - b

  const firstFactor = 0.5
  const secondFactor = 0.8

  const firstShade = rgbToHex(
    r + rRest * firstFactor,
    g + gRest * firstFactor,
    b + bRest * firstFactor,
  )

  const secondShade = rgbToHex(
    r + rRest * secondFactor,
    g + gRest * secondFactor,
    b + bRest * secondFactor,
  )

  return {
    color: color.toHexString(),
    firstShade,
    secondShade,
  }
}
